import { APP_SAVE_BAR_SCOPE } from "@/modules/app-save-bar";

export const ASSET_TECHNICAL_UPDATE_SCOPE =
  APP_SAVE_BAR_SCOPE.ASSET_TECHNICAL_DATA_EDITOR;
